<template>
  <div class="form-input w-100" :class="item.position ? 'text-' + props.item.position : ''">
    <img v-if="getImage" :src="getImage" alt="Image" :height="item.height"/>
  </div>
</template>

<script setup>
import {reactive, watch, defineProps, computed} from 'vue';
import {useUserStore} from "@/api/store/user";
import { useSettingsStore } from "@/api/store/settings";

const userStore = useUserStore();
const settingsStore = useSettingsStore();

const props = defineProps({
  item: Object,
});

const getImage = computed(() => {
  if (props.item.source === 'logo') {
    // Prefer clinic avatar if present, otherwise fall back to app branding image
    return userStore?.user?.file?.file_path || settingsStore?.settings?.brandingImg || ''
  }

  return props.item.content || '';
})
</script>